import {
  UPDATE_TAGSLOADING_STATUS,
  FETCH_TAGS_DATA_LIST,
  GET_TAGSBLACKLISTNULL_LIST
} from "../actions/tagsManage";

const defVal = {
  dataListLoading: false,
  dataList: [],
  total: 0,
  isDataList: true
};

export default (state = defVal, action) => {
  switch (action.type) {
    case UPDATE_TAGSLOADING_STATUS:
      return Object.assign({}, state, {
        dataListLoading: action.loading
      });

    case FETCH_TAGS_DATA_LIST:
      return Object.assign({}, state, {
        dataList: action.dataList,
        total: action.total,
      });
    case GET_TAGSBLACKLISTNULL_LIST:
      return Object.assign({}, state, {
        isDataList: action.isDataList || false,
      });
    default:
      return state;
  }
};
